export const Features = [
  {
    "serviceName": "CardsManageService.Dashboard",
    "title": "Dashboard",
    "icon": "Dashboard",
    "Name": "Dashboard",
    "Features": [],
    "isTabs": [], path: '/dashboard', key: '1', "isEnabled": false
  },

  {
    "serviceName": "CardsManageService.Customers",
    "title": "Customers",
    "icon": "Customers",
    "Name": "Customers",
    "Features": [], "isEnabled": false, "actions": [{ Name: "CasesAdd", "isEnabled": false, icon: "add-cases", title: "Create Case" }, { Name: "ExportExcel", "isEnabled": false, icon: "excel", title: "Export Excel" }],
    "isTabs": [
      {
        "serviceName": "CardsManageService.Customers",
        "title": "KYC",
        "icon": "",
        "Name": "KYC",
        "Features": [],
        "isTabs": [], key: 'sub1', "isEnabled": false, path: '/customer/:id/customerKyc'
      },
      {
        "serviceName": "CardsManageService.Customers",
        "title": "Transactions",
        "icon": "",
        "Name": "Transactions",
        "Features": [],
        "isTabs": [], key: 'sub2', "isEnabled": false, path: '/customer/:id/customerTransactions'
      },
      {
        "serviceName": "CardsManageService.Customers",
        "title": "Cards",
        "icon": "",
        "Name": "Cards",
        "Features": [],
        "isTabs": [], key: 'sub3', "isEnabled": false, path: '/customer/:id/customerCards', Actions: [{ Name: "Freeze", isEnabled: false }]
      },

    ], path: '/customers', key: '2'
  },
  {
    "serviceName": "CardsManageService.Wallets",
    "title": "Wallets",
    "icon": "Wallets",
    "Name": "Wallets", path: 'wallets', key: '3',
    "isTabs": [
      {
        "serviceName": "CardsManageService.Wallets",
        "title": "Portfolio",
        "icon": "",
        "Name": "Portfolio",
        "Features": [],
        "isTabs": [], key: 'sub1', "isEnabled": false, path: '/accountoverview/portfolio'
      },
      {
        "serviceName": "CardsManageService.Wallets",
        "title": "Wallets",
        "icon": "",
        "Name": "Wallets",
        "Features": [],
        "isTabs": [], key: 'sub2', "isEnabled": false, path: '/accountoverview/wallets'
      }
    ]
  },


  {
    "serviceName": "CardsManageService.Cards",
    "title": "Cards",
    "icon": "Cards",
    "Name": "Cards",
    "Features": [],
    "isTabs": [
      {
        "serviceName": "CardsManageService.Cards",
        "title": "Transactions",
        "icon": "",
        "Name": "Transactions",
        "Features": [],
        "isTabs": [], key: 'sub1', "isEnabled": false, path: '/cards/cardDetails/:id/transactions'
      },
      {
        "serviceName": "CardsManageService.Cards",
        "title": "Authorization Records",
        "icon": "",
        "Name": "AuthorizationRecords",
        "Features": [],
        "isTabs": [], key: 'sub2', "isEnabled": false, path: '/cards/cardDetails/:id/authorizationRecord'
      },
      {
        "serviceName": "CardsManageService.Cards",
        "title": "Operations",
        "icon": "",
        "Name": "Operations",
        "Features": [],
        "isTabs": [], key: 'sub3', "isEnabled": false, path: '/cards/cardDetails/:id/operations'
      }
    ], path: '/cards', key: '4', "actions": [{ Name: "ExportExcel", "isEnabled": false, icon: "excel", title: "Export Excel" }], "isEnabled": false
  },
  {
    "serviceName": "CardsManageService.CardActivity",
    "title": "Card Activity",
    "icon": "Card Operations",
    "Name": "Card Activity",
    "Features": [],
    "isTabs": [], path: '/cardactivity', key: '5', "isEnabled": false, "actions": [{ Name: "ExportExcel", "isEnabled": false, icon: "excel", title: "Export Excel" },]
  },
  {
    "serviceName": "CardsManageService.Operations",
    "title": "Operations",
    "icon": "Activity Logs",
    "Name": "Operations", path: '/operations', key: '6',
    "isTabs": [], "isEnabled": false, "actions": [{ Name: "ExportExcel", "isEnabled": false, icon: "excel", title: "Export Excel" },]
  },
  {
    "serviceName": "CardsManageService.ActivityLogs",
    "title": "Activity Log",
    "icon": "Activity Logs",
    "Name": "Activity Logs", path: '/activitylogs', key: '7',
    "isTabs": [], "isEnabled": false, "actions": [{ Name: "ExportExcel", "isEnabled": false, icon: "excel", title: "Export Excel" },]
  },
  {
    "serviceName": "CardsManageService.Transactions",
    "title": "Transactions",
    "icon": "Card Transactions",
    "Name": "Transactions",
    "Features": [],
    "isTabs": [], path: '/cardtransactions', key: '8', "isEnabled": false, "actions": [{ Name: "CasesAdd", "isEnabled": false, icon: "add-cases", title: "Create Case" }, { Name: "ExportExcel", "isEnabled": false, icon: "excel", title: "Export Excel" },]
  },
  {
    "serviceName": "CardsManageService.Energy",
    "title": "Energy",
    "icon": "energy-icon",
    "Name": "Energy", path: '/energy', key: '9',
    "isTabs": [], "isEnabled": false, "actions": [{ Name: "ExportExcel", "isEnabled": false, icon: "excel", title: "Export Excel" },]
  },
  {
    "serviceName": "CardsManageService.Services",
    "title": "Services",
    "icon": "Services",
    "Name": "Services", path: '/services', key: '10',
    "isTabs": [], "isEnabled": false, "actions": [{ Name: "ExportExcel", "isEnabled": false, icon: "excel", title: "Export Excel" },]
  },
  {
    "serviceName": "CardsManageService.Settings",
    "title": "Settings",
    "icon": "settings",
    "Name": "Settings",
    "Features": [],
    path: '/settings/config', key: '11', "isEnabled": false, "isTabs": [
      // {
      //   "serviceName": "CardsManageService.Settings",
      //   "title": "Programs",
      //   "icon": "Programs",
      //   "Name": "Programs",
      //   "Features": [],
      //   "isTabs": [], path: '/settings/programs', key: 'sub1', "isEnabled": false,
      //    "actions": [
      //     // { Name: "ExportExcel", "isEnabled": false, icon: "excel", title: "Export Excel" },

      //    ]
      // },
      {
        "serviceName": "CardsManageService.Settings.Config",
        "title": "Config",
        "icon": "Developer Config",
        "Name": "Config",
        "Features": [], path: '/settings/config', key: 'sub2', "isEnabled": false,
        "isTabs": [
          {
            "serviceName": "CardsManageService.Settings.Config",
            "title": "Push Config",
            "icon": "",
            "Name": "PushConfig",
            "Features": [],
            "isTabs": [], key: 'sub11', "isEnabled": false, path: '/settings/config/pushconfig'
          },
          {
            "serviceName": "CardsManageService.Settings.Config",
            "title": "API Encryption",
            "icon": "",
            "Name": "APIEncryption",
            "Features": [],
            "isTabs": [], key: 'sub22', "isEnabled": false, path: '/settings/config/apiEncryption'
          },
          {
            "serviceName": "CardsManageService.Settings.Config",
            "title": "API Keys",
            "icon": "",
            "Name": "APIKeys",
            "Features": [],
            "isTabs": [], key: 'sub33', "isEnabled": false, path: '/settings/config/apiKeys'
          }
        ]
      },

      {
        "serviceName": "CardsManageService.Settings",
        "title": "Roles",
        "icon": "Roles",
        "Name": "Roles",
        "Features": [],
        "isTabs": [], path: '/settings/roles', key: 'sub3', "actions": [
          // { Name: "Add", "isEnabled": false, icon: "add", title: "Add" }, { Name: "Edit", "isEnabled": false, icon: "edit", title: "Edit" }, 
          { Name: "ManagePermission", "isEnabled": false, icon: "permisson", title: "Manage Permissions" }, 
          // { Name: "Delete", "isEnabled": false, icon: "delete", title: "Delete" }
        ], "isEnabled": false
      },
      {
        "serviceName": "CardsManageService.Settings",
        "title": "Users",
        "icon": "Users",
        "Name": "Users",
        "Features": [],
        "isTabs": [], path: '/settings/users', key: 'sub4', "actions": [{ Name: "Add", "isEnabled": false, icon: "add", title: "Add" }, { Name: "Edit", "isEnabled": false, icon: "edit", title: "Edit" }], isEnabled: false
      },
    ],
  },

  {
    "serviceName": "CardsManageService.Cases",
    "title": "Cases",
    "icon": "Cases",
    "Name": "Cases",
    "Features": [],
    "path": '/cases/casesgrid', key: '12', isEnabled: false,
    "isTabs": [
      {
        "serviceName": "CardsManageService.Cases",
        "title": "Cases",
        "icon": "",
        "Name": "Cases",
        "Features": [], "actions": [{ Name: "Edit", "isEnabled": false, icon: "edit", title: "Edit" }, { Name: "StateChange", "isEnabled": false, icon: "stateChange", title: "State Change" }, { Name: "ExportExcel", "isEnabled": false, icon: "excel", title: "Export Excel" },],
        "isTabs": [], key: 'sub1', "isEnabled": false, path: '/cases/casesgrid'
      },
      // {
      //   "serviceName": "CardsManageService.Cases",
      //   "title": "Templates",
      //   "icon": "",
      //   "Name": "Templates",
      //   "Features": [],
      //   "isTabs": [], key: 'sub2', "isEnabled": false, path: '/cases/templates',
      //    "actions": [{ Name: "Add", "isEnabled": false, icon: "Add", title: "Add" },{ Name: "Edit", "isEnabled": false, icon: "edit", title: "Edit" },  { Name: "Delete", "isEnabled": false, icon: "delete", title: "Delete" },]
      // },
    ],
  }, {
    "serviceName": "CardsManageService.Reports",
    "title": "Reports",
    "icon": "Reports",
    "Name": "Reports",
    "Features": [],
    "isTabs": [], path: '/reports', key: '13'
  },

]
export function manageAcntFeatures() {
  return {
    "serviceName": "CardsManageService.ManageAccount",
    "title": "Manage Account",
    "icon": "",
    "Name": "Manage Account",
    "Features": [], path: '/profile', key: 'sub21', "isEnabled": false,
    "isTabs": [
      {
        "serviceName": "CardsManageService.ManageAccount",
        "title": "Personal Profile",
        "icon": "",
        "Name": "PersonalProfile",
        "Features": [],
        "isTabs": [], key: '1', "isEnabled": false, path: '/profile/personalInfo'
      },
      {
        "serviceName": "CardsManageService.ManageAccount",
        "title": "Change Password",
        "icon": "",
        "Name": "ChangePassword",
        "Features": [],
        "isTabs": [], key: '2', "isEnabled": false, path: '/profile/changePassword'
      },
      {
        "serviceName": "CardsManageService.ManageAccount",
        "title": "Authenticator App",
        "icon": "",
        "Name": "AuthenticatorApp",
        "Features": [],
        "isTabs": [], key: '3', "isEnabled": false, path: '/profile/authenticatorApp'
      }, {
        "serviceName": "CardsManageService.ManageAccount",
        "title": "KYB",
        "icon": "",
        "Name": "KYB",
        "Features": [],
        "isTabs": [], key: '4', "isEnabled": false, path: '/profile/kyb'
      }
    ]
  }
}